import { SegmentProvider } from 'app/modules/Segment/SegmentProvider';
import { registerSegmentEventContextMiddleware } from 'app/services/tracking/segmentIdentity';
import { AnalyticsTracker } from './AnalyticsTracker';

registerSegmentEventContextMiddleware();

const SegmentProviderInstance = new SegmentProvider();

const eventTracker = new AnalyticsTracker(SegmentProviderInstance);

export { eventTracker };
